import { Article } from './article.model';

/**
 * Transform Article model to Article Json for the API
 */
export class AddArticleCommand {
    public language: string;
    public title: string;

    constructor(tempArticle: Article) {
        if (tempArticle) {
            this.language = tempArticle.language;
            this.title = tempArticle.translations[0].title;
        }
    }
}
